import { Base } from '../base.model';

// Internal Chat models (SPEC-2026-07-internal-chat, T-16).
// Manual mirror of trendmulti-apps/libs/trendmulti-entity/src/entity/chat/
// chat-user-setting.entity.ts — enum values MUST stay byte-identical to the
// backend contract.

export enum ChatAvailabilityEnum {
  ACTIVE = 'ACTIVE',
  BUSY = 'BUSY',
  AWAY = 'AWAY',
}

export interface ChatUserSetting extends Base {
  /** User id (appdb) — string only, never populated */
  user: string;
  /** Company id (appdb) — string only, never populated */
  company: string;
  /** manual availability override */
  availability: ChatAvailabilityEnum;
  statusEmoji?: string;
  statusText?: string;
  statusExpiresAt?: Date;
  quietHoursEnabled: boolean;
  /** "HH:mm" */
  quietHoursStart?: string;
  /** "HH:mm" */
  quietHoursEnd?: string;
  soundEnabled: boolean;
}
